import { CompanyAccountType } from '@hr-outsourcing/shared';
import type { AccountTypeUser } from '@/types/accountType';

export const LISTING_ONLY_HOME_PATH = '/positions';
// Team management page of a listing-only company.
export const LISTING_TEAM_PATH = '/team';

// Menu items a listing-only company sees (Layout navigation keys).
export const LISTING_ONLY_NAV_KEYS: ReadonlySet<string> = new Set([
  'positions',
  'applications',
  'candidateMatching',
  'skills',
  'notifications',
  'team',
  'companySettings',
  'accountSettings',
]);

// Pages a listing-only company may open; anything else redirects to the home path.
const LISTING_ONLY_PATH_PREFIXES = [
  '/positions',
  '/applications',
  '/candidate-matching',
  '/skills-and-titles',
  '/notifications',
  LISTING_TEAM_PATH,
  // The company's own details only (name, address, country).
  '/settings',
  '/account-settings',
];
// Own profile settings only; /profile/360-results belongs to the performance module.
const LISTING_ONLY_EXACT_PATHS = ['/profile'];

export const isListingOnlyUser = (user: AccountTypeUser | null | undefined): boolean =>
  !!user && !user.isSuperAdmin && user.accountType === CompanyAccountType.LISTING_ONLY;

export const isPathAllowedForListingOnly = (pathname: string): boolean =>
  LISTING_ONLY_EXACT_PATHS.includes(pathname) ||
  LISTING_ONLY_PATH_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));

export const getHomePath = (user: AccountTypeUser | null | undefined): string => {
  if (!user) return '/';
  if (user.isSuperAdmin) return '/companies';
  if (user.isCompany) return '/company-dashboard';
  if (isListingOnlyUser(user)) return LISTING_ONLY_HOME_PATH;
  return '/dashboard';
};
